import { render, staticRenderFns } from "./instr-tmpl-item.vue?vue&type=template&id=80d25048&"
import script from "./instr-tmpl-item.vue?vue&type=script&lang=ts&"
export * from "./instr-tmpl-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports